import mapFolderIdToBaseSearchScope from '../helpers/mapFolderIdToBaseSearchScope';
import type SuggestionKind from 'owa-service/lib/contract/SuggestionKind';
import type WarmupOptions from 'owa-service/lib/contract/WarmupOptions';
import startSearchSessionRequest from 'owa-service/lib/factory/startSearchSessionRequest';
import startSearchSessionOperation from 'owa-service/lib/operation/startSearchSessionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export default function startSearchSessionService(
    sessionGuid: string,
    staticFolderScopeId: string
) {
    startSearchSessionOperation({
        Header: getJsonRequestHeader(),
        Body: startSearchSessionRequest({
            SearchSessionId: sessionGuid,
            WarmupOptions: 16777215,
            SuggestionTypes: 1,
            SearchScope: mapFolderIdToBaseSearchScope(staticFolderScopeId),
            IdFormat: 'EwsId',
            ApplicationId: 'Owa',
        }),
    });
}
